export const endDate = (dateString: string) =>
  new Date(dateString).toISOString().slice(0, 10) + 'T23:59:59.999Z';
